import { Center, Text } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";
import { useEffect } from "react";

export default function Finish(props: any) {
  const queryArgs = new URLSearchParams(window.location.search);
  return (
    <>
      <Center>
        <Text size="xl">Click the finish button to continue.</Text>
      </Center>
      <Center>
        <Text></Text>
      </Center>
      <Center m="xl">
        <IconCircleCheck color="#1971c2" size={100} />
      </Center>
    </>
  );
}
